import {
  ActionIcon,
  Box,
  Code,
  CopyButton,
  ScrollArea,
  Tooltip
} from '@mantine/core'
import { IconCopy } from '@tabler/icons-react'
import { PropsWithChildren } from 'react'
import { FormattedMessage } from 'react-intl'

type CodeSnippetProps = PropsWithChildren<{
  maxHeight?: number
  fontSize?: number
  showCopyButton?: boolean
  copyValue?: string
}>

export const CodeSnippet = ({
  children,
  maxHeight,
  fontSize,
  showCopyButton = true,
  copyValue
}: CodeSnippetProps) => {
  const content = (
    <Box pos="relative">
      <Code
        fz={fontSize}
        styles={{
          root: {
            whiteSpace: 'pre-wrap',
            overflowWrap: 'break-word',
            paddingRight: showCopyButton ? 40 : undefined
          }
        }}
        block
      >
        {children}
      </Code>

      {showCopyButton && (
        <Box pos="absolute" top={4} right={8}>
          <CopyButton value={copyValue || ''}>
            {({ copied, copy }) => (
              <Tooltip
                label={
                  copied ? (
                    <FormattedMessage id="general.clipboard.copied" />
                  ) : (
                    <FormattedMessage id="general.clipboard.copy" />
                  )
                }
                withArrow
              >
                <ActionIcon variant="subtle" onClick={copy}>
                  <IconCopy size={16} />
                </ActionIcon>
              </Tooltip>
            )}
          </CopyButton>
        </Box>
      )}
    </Box>
  )

  return maxHeight !== undefined ? (
    <ScrollArea h={maxHeight}>{content}</ScrollArea>
  ) : (
    content
  )
}
